export default __webpack_public_path__ + "static/og-image-64ff48dc9f370e45dcad2926190b9ad0.png";